module.exports = __webpack_public_path__ + "static/media/ryan-bubinski_200x200.1b2726f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/ryan-bubinski_200x200.png
// module id = 313
// module chunks = 0